import _ from 'lodash'
import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { ChartData } from 'chart.js'
import { format, subWeeks } from 'date-fns'
import { getAbittiExamStatistics } from './utils/abitti-exam-statistics-api'
import { StackedAreaChart } from './StackedAreaChart'
import { getAbittiExamsChartDataCounts, getAbittiExamsChartDataPercentages } from './utils/abitti-exams-chart-data'

const initialChartDataState = {
  labels: [],
  datasets: [],
}

export function AbittiExamStatistics() {
  const [weeksInput, setWeeksInput] = useState<string>('4')
  const weeks = Number(weeksInput)
  const [examsPerWeek, setExamsPerWeek] = useState<ChartData<'line'>>(initialChartDataState)
  const [answerPapersPerWeek, setAnswerPapersPerWeek] = useState<ChartData<'line'>>(initialChartDataState)
  const [examsPerWeekPercentages, setExamsPerWeekPercentages] = useState<ChartData<'line'>>(initialChartDataState)
  const [answerPapersPerWeekPercentages, setAnswerPapersPerWeekPercentages] =
    useState<ChartData<'line'>>(initialChartDataState)
  const [totalExams, setTotalExams] = useState<number>(0)
  const [totalAnswerPapers, setTotalAnswerPapers] = useState<number>(0)

  useEffect(() => {
    if (!Number.isInteger(weeks) || weeks < 2) return
    const fetchExamStatistics = async () => {
      const startWeek = format(subWeeks(new Date(), weeks - 1), 'R-II')
      const examStatistics = await getAbittiExamStatistics({ startWeek })
      setExamsPerWeek(getAbittiExamsChartDataCounts(examStatistics, 'exam_count'))
      setAnswerPapersPerWeek(getAbittiExamsChartDataCounts(examStatistics, 'answer_paper_count'))
      setExamsPerWeekPercentages(getAbittiExamsChartDataPercentages(examStatistics, 'exam_count'))
      setAnswerPapersPerWeekPercentages(getAbittiExamsChartDataPercentages(examStatistics, 'answer_paper_count'))
      setTotalExams(_.sumBy(examStatistics, 'exam_count'))
      setTotalAnswerPapers(_.sumBy(examStatistics, 'answer_paper_count'))
    }
    fetchExamStatistics()
  }, [weeks])

  return (
    <div
      className={clsx(
        'border',
        'rounded overflow-hidden',
        'shadow-sm',
        'flex items-start flex-col',
        'border-b',
        'bg-neutral-100',
        'mt-5',
      )}
    >
      <div className="flex items-center text-lg font-mono border-b w-full pl-5 p-4">
        <span className="flex-grow">Abitti Exam Statistics</span>
        <label className="flex items-center gap-2 text-sm font-normal">
          Weeks:
          <input
            type="number"
            min={2}
            value={weeksInput}
            onChange={(e) => setWeeksInput(e.target.value)}
            className="w-20 rounded border px-2 py-1"
          />
        </label>
      </div>
      <div className="p-4 w-full grid grid-cols-1 xl:grid-cols-2 gap-8">
        <StackedAreaChart
          title={`Exams per week (${totalExams.toLocaleString('fi-FI')} total)`}
          chartData={examsPerWeek}
        />
        <StackedAreaChart
          title={`Answer papers per week (${totalAnswerPapers.toLocaleString('fi-FI')} total)`}
          chartData={answerPapersPerWeek}
        />
        <StackedAreaChart
          title="Exams per week (percentages)"
          chartData={examsPerWeekPercentages}
          yScaleIsPercentages={true}
        />
        <StackedAreaChart
          title="Answer papers per week (percentages)"
          chartData={answerPapersPerWeekPercentages}
          yScaleIsPercentages={true}
        />
      </div>
    </div>
  )
}
